module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Light-881c25ce65912301928c75c292d8a9ae.eot";